import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle, faTimes } from '@fortawesome/free-solid-svg-icons';

const Alert = ({ type, message, onClose }) => {
    let bgColor, icon;

    if (type === 'success') {
        bgColor = 'bg-green-100';
        icon = faCheckCircle;
    } else if (type === 'error') {
        bgColor = 'bg-red-100';
        icon = faExclamationCircle;
    }

    return (
        <div className={`fixed top-4 left-1/2 transform -translate-x-1/2 w-11/12 sm:w-1/2 md:w-1/3 lg:w-1/4 border-l-4 p-4 ${bgColor} rounded-lg shadow-lg flex items-start justify-between`}>
            <div className="flex items-center">
                <FontAwesomeIcon icon={icon} className="text-2xl text-current mr-3" />
                <div>
                    <h4 className="text-lg font-semibold">
                        {type === 'success' ? 'Success!' : 'Error!'}
                    </h4>
                    <p className="text-sm">{message}</p>
                </div>
            </div>
            <button onClick={onClose} className="text-lg font-bold ml-4">
                <FontAwesomeIcon icon={faTimes} />
            </button>
        </div>
    );
};

export default Alert;
